const ESTATUS_PREASPIRANTE = 7
const ESTATUS_CANDIDATO = 8

export default {
  methods: {
    isPreaspiranteOCandidato(estatus) {
      return estatus === ESTATUS_PREASPIRANTE || estatus === ESTATUS_CANDIDATO
    },
  },
}
